import { RealtyInfo } from 'shared/api/kyrgyzstan/search'
import { AllIcons } from 'shared/ui/app-icon/types'

export const mockData: RealtyInfo[] = [
  {
    id: '1',
    title: 'kyrgyzstan_block.policy.title_one',
    subtitle: 'kyrgyzstan_block.policy.subtitle_one',
    description: 'kyrgyzstan_block.policy.description_one',
    icon: AllIcons.OPEN_BOOK,
  },
  {
    id: '2',
    title: 'kyrgyzstan_block.policy.title_two',
    subtitle: 'kyrgyzstan_block.policy.subtitle_two',
    description: 'kyrgyzstan_block.policy.description_two',
    icon: AllIcons.CANCEL_MONEY,
    isShowReturnPolicy: true,
  },
  {
    id: '3',
    title: 'kyrgyzstan_block.policy.title_three',
    subtitle: 'kyrgyzstan_block.policy.subtitle_three',
    description: 'kyrgyzstan_block.policy.description_three',
    icon: AllIcons.SHIELD,
  },
]
